export default __webpack_public_path__ + "static/media/flower.86e93e93.jpg";